// extracted by mini-css-extract-plugin
export var Block = "styles-module--Block--bn-GP";
export var Container = "styles-module--Container--rO-Rb";
export var Img = "styles-module--Img--yJksr";
export var Section = "styles-module--Section--OnqYb";
export var Title = "styles-module--Title--UJ3lu";
export var Wrapper = "styles-module--Wrapper--2QM0W";